import {
  FaStore,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaClock,
  FaMotorcycle,
  FaShieldAlt,
} from "react-icons/fa";

import "./ProviderBusinessInfo.css";

export default function ProviderBusinessInfo({
  provider,
}) {
  if (!provider) return null;

  return (
    <section className="provider-business-section">

      <h2>Business Information</h2>

      <div className="provider-business-card">

        <div className="business-row">
          <FaStore className="business-icon" />

          <div>
            <h4>Business Name</h4>
            <p>{provider.business?.name}</p>
          </div>
        </div>

        <div className="business-row">
          <FaMapMarkerAlt className="business-icon" />

          <div>
            <h4>Address</h4>
            <p>
              {provider.address?.street},{" "}
              {provider.address?.area},{" "}
              {provider.address?.city},{" "}
              {provider.address?.state}
            </p>
          </div>
        </div>

        <div className="business-row">
          <FaPhoneAlt className="business-icon" />

          <div>
            <h4>Phone Number</h4>
            <p>{provider.phone}</p>
          </div>
        </div>

        <div className="business-row">
          <FaClock className="business-icon" />

          <div>
            <h4>Business Hours</h4>
            <p>
              {provider.businessHours?.open || "9:00 AM"} -
              {" "}
              {provider.businessHours?.close || "9:00 PM"}
            </p>
          </div>
        </div>

        <div className="business-row">
          <FaMotorcycle className="business-icon" />

          <div>
            <h4>Delivery Radius</h4>
            <p>
              {provider.deliveryRadius || 5} km
            </p>
          </div>
        </div>

        <div className="business-row">
          <FaShieldAlt className="business-icon" />

          
        </div>

      </div>

    </section>
  );
}